import {
  GET_BUTTON_REPAIR_MOVEMENT,
  GET_FINAL_SEAL_MOVEMENT,
  GET_REPAIR_SEAL_MOVEMENT,
} from 'shared/constants/ActionTypes';

const initialState = {
  newNoSeal: [],
  repairNoSeal: [],
  buttonRepair: false,
  sealNoList: [],
  finalSeal: [],
};

const repairNoSealCashMovementReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_NEW_NO_SEAL':
      return {
        ...state,
        newNoSeal: action.payload,
      };

    case 'RESET_NEW_NO_SEAL':
      return {
        ...state,
        newNoSeal: action.payload,
      };

    case 'SELECT_REPAIR_NO_SEAL':
      return {
        ...state,
        repairNoSeal: action.payload,
      };

    case GET_BUTTON_REPAIR_MOVEMENT:
      return {
        ...state,
        buttonRepair: action.payload,
      };
    case GET_REPAIR_SEAL_MOVEMENT:
      return {
        ...state,
        sealNoList: action.payload,
      };
    case GET_FINAL_SEAL_MOVEMENT:
      return {
        ...state,
        finalSeal: action.payload,
      };

    default:
      return state;
  }
};

export default repairNoSealCashMovementReducers;
